<template>
  <div class="flex items-center gap-6">
    <div class="flex items-center justify-center rounded-md h-7 relative z-10">
      <button
        class="w-10 h-7 text-gray-500 font-normal"
        @click.prevent="selectedNumberOfRow(5)"
        :class="[
          selectedNum === 5
            ? 'bg-blue-600 border-blue-600 text-white rounded-l'
            : 'border-l border-t border-b rounded-s border-brand-gray-600'
        ]"
      >
        5
      </button>
      <button
        class="w-10 h-7 relative z-0 text-gray-500 font-normal"
        @click.prevent="selectedNumberOfRow(10)"
        :class="[
          selectedNum === 10
            ? 'bg-blue-600 border-blue-600 text-white'
            : 'border border-brand-gray-600'
        ]"
      >
        10
      </button>
      <button
        class="w-10 h-7 relative z-0 text-gray-500 font-normal"
        @click.prevent="selectedNumberOfRow(20)"
        :class="[
          selectedNum === 20
            ? 'bg-blue-600 border-blue-600 text-white rounded-r'
            : 'border-r border-t border-b rounded-e border-brand-gray-600'
        ]"
      >
        20
      </button>
    </div>
    <div class="w-fit">
      <span class="text-gray-700 text-sm font-normal capitalize">
        {{
          $t('showingPage', {
            start: props.currentPage,
            end: pageLength,
            total: pagination.totalItemCount
          })
        }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const emits = defineEmits(['seleted'])

const props = defineProps({
  pageLength: {
    type: Number,
    required: true
  },
  pagination: {
    type: Object,
    default: () => {}
  },
  currentPage: {
    type: String
  }
})

const selectedNum = ref()

const selectedNumberOfRow = (num) => {
  selectedNum.value = num
  emits('seleted', num)
}

onMounted(() => {
  selectedNum.value = props.pageLength
})
</script>
